// extracted by mini-css-extract-plugin
module.exports = {"main":"StatusWarning_main__CKuyk"};